import { render, staticRenderFns } from "./BuildingCostAnalysisTab.vue?vue&type=template&id=6f6a3459"
import script from "./BuildingCostAnalysisTab.vue?vue&type=script&lang=js"
export * from "./BuildingCostAnalysisTab.vue?vue&type=script&lang=js"
import style0 from "./BuildingCostAnalysisTab.vue?vue&type=style&index=0&id=6f6a3459&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VTooltip})
